import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { PersonInfoComponent } from './components/nonanon/person/person-info.component';

import { VehicleComponent } from "./components/nonanon/vehicle/vehicle.component";
import { VehicleInfoComponent } from './components/nonanon/vehicle/vehicle-info.component';
import { VehicleOwnersComponent } from './components/nonanon/vehicle/vehicle-owners.component';

import { WelcomeComponent } from "./components/anon/welcome.component";
import { LoginComponent } from "./components/anon/login.component";
import { ResetPasswordComponent } from './components/anon/reset-password.component';
import { PasswordChangeComponent } from './components/anon/password-change.component';
import { TermsOfServiceComponent } from './components/anon/terms-of-service.component';

import { AuthGuard } from "./services/auth/auth.guard";
import { ColorResolver } from "./services/lookups/color-resolver.service";
import { ProvinceResolver } from "./services/lookups/province-resolver.service";
import { NotAllowedComponent } from "./components/nonanon/not-allowed.component";
import { AuthOnlyGuard } from "./services/auth/authOnly.guard";

const appRoutes: Routes = [
  { path: '', component: WelcomeComponent, pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'change-password', component: PasswordChangeComponent, canActivate: [AuthOnlyGuard] },
  { path: 'change-password-reset', component: PasswordChangeComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'terms-of-service', component: TermsOfServiceComponent, canActivate: [AuthOnlyGuard] },
  {
    path: 'search', component: VehicleComponent, canActivate: [AuthGuard], canActivateChild: [AuthGuard],
    data: { securityItem: 'canAccessSearch' },
    resolve: { colors: ColorResolver, provinces: ProvinceResolver },
    children: [
      { path: 'not-allowed', component: NotAllowedComponent },
    ]
  },
  { path: 'not-allowed', component: NotAllowedComponent },
  { path: '**', redirectTo: '/', pathMatch: 'full' } /*Needs to be last one*/
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/app-routing.module.ts